/**
 * external libs
 */
import React from 'react'
/**
 * components
 */
import WidgetAge from '../../../../Widget/components/UIWidget/WidgetAge'
import WidgetGenderIcon from '../../../../Widget/components/UIWidget/WidgetGenderIcon'
/**
 * styles
 */
import styles from './index.module.scss'

export default function GenderItem({genderResult, birthDayResult, deathDayResult}){
    return (
        <div className={styles.gender}>
            {genderResult && (
                <WidgetGenderIcon result={genderResult}/>
            )}
            {birthDayResult && (
                <WidgetAge birthDayResult={birthDayResult} deathDayResult={deathDayResult}/>
            )}
        </div>
    )
}

